import { render, staticRenderFns } from "./InterfaceGateway.vue?vue&type=template&id=62db2540"
import script from "./InterfaceGateway.vue?vue&type=script&lang=js"
export * from "./InterfaceGateway.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports